export const clientRequestEmailTemplate = (
    name,
    message,
    email,
    phone_number,
    workorder_id
  ) => {
    return `
    <!DOCTYPE html>
  
  <html
    lang="en"
    xmlns:o="urn:schemas-microsoft-com:office:office"
    xmlns:v="urn:schemas-microsoft-com:vml"
  >
    <head>
      <title></title>
      <meta content="text/html; charset=utf-8" http-equiv="Content-Type" />
      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      <link
      href="https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
      rel="stylesheet"
      type="text/css"
    />
      <!--[if mso
        ]><xml
          ><o:OfficeDocumentSettings
            ><o:PixelsPerInch>96</o:PixelsPerInch
            ><o:AllowPNG /></o:OfficeDocumentSettings></xml
      ><![endif]-->
      <style>
        * {
          box-sizing: border-box;
        }
  
        body {
          margin: 0;
          padding: 0;
          font-family: Jost;
        }
  
        a[x-apple-data-detectors] {
          color: inherit !important;
          text-decoration: inherit !important;
        }
  
        #MessageViewBody a {
          color: inherit;
          text-decoration: none;
        }
  
        p {
          line-height: inherit;
          font-family: Jost;
        }
  
        span {
            font-family: Jost;
        }
  
        .desktop_hide,
        .desktop_hide table {
          mso-hide: all;
          display: none;
          max-height: 0px;
          overflow: hidden;
        }
  
        .image_block img + div {
          display: none;
        }
  
        @media (max-width: 700px) {
          .desktop_hide table.icons-inner,
          .social_block.desktop_hide .social-table {
            display: inline-block !important;
          }
  
          .icons-inner {
            text-align: center;
          }
  
          .icons-inner td {
            margin: 0 auto;
          }
  
          .fullMobileWidth,
          .row-content {
            width: 100% !important;
          }
  
          .mobile_hide {
            display: none;
          }
  
          .stack .column {
            width: 100%;
            display: block;
          }
  
          .mobile_hide {
            min-height: 0;
            max-height: 0;
            max-width: 0;
            overflow: hidden;
            font-size: 0px;
          }
  
          .desktop_hide,
          .desktop_hide table {
            display: table !important;
            max-height: none !important;
          }
  
          .reverse {
            display: table;
            width: 100%;
          }
  
          .reverse .column.last {
            display: table-header-group !important;
          }
  
          .row-5 td.column.last .border {
            padding: 0;
            border-top: 0;
            border-right: 0px;
            border-bottom: 0;
            border-left: 0;
          }
        }
      </style>
    </head>
    <body
      style="
        background-color: #f9f9f9;
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: none;
        text-size-adjust: none;
      "
    >
      <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        class="nl-container"
        role="presentation"
        style="
          mso-table-lspace: 0pt;
          mso-table-rspace: 0pt;
          background-color: #f9f9f9;
        "
        width="100%"
      >
        <tbody>
          <tr>
            <td>
              
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-2"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #ff9c27;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                              width="100%"
                            >
                              <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                class="image_block block-1"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td
                                    class="pad"
                                    style="
                                      width: 100%;
                                      padding-right: 0px;
                                      padding-left: 0px;
                                    "
                                  >
                                    <div
                                      align="center"
                                      class="alignment"
                                      style="line-height: 10px"
                                    >
                                      <img
                                        alt="Yourlogo Light"
                                        src="https://ik.imagekit.io/0hhctrxcv/zivainteriors/zivalogo_black.png"
                                        style="
                                          display: block;
                                          height: auto;
                                          border: 0;
                                          width: 204px;
                                          max-width: 100%;
                                        "
                                        title="Yourlogo Light"
                                        width="204"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-4"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #f6d16c;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                              width="100%"
                            >
                              <div
                                class="spacer_block"
                                style="
                                  height: 80px;
                                  line-height: 80px;
                                  font-size: 1px;
                                "
                              >
                                 
                              </div>
                              <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                class="image_block block-2"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td
                                    class="pad"
                                    style="
                                      width: 100%;
                                      padding-right: 0px;
                                      padding-left: 0px;
                                    "
                                  >
                                    <div
                                      align="center"
                                      class="alignment"
                                      style="line-height: 10px"
                                    >
                                      <img
                                        alt="Bell Icon"
                                        src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Fclient_email_template_images%2Fbell-icon.png?alt=media&token=ca3c045e-19fe-404e-87ea-1220f00293c7"
                                        style="
                                          display: block;
                                          height: auto;
                                          border: 0;
                                          width: 92px;
                                          max-width: 100%;
                                        "
                                        title="Bell Icon"
                                        width="92"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-5"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #f6d16c;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr class="reverse">
                            <td
                              class="column column-1 last"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                              width="100%"
                            >
                              <div class="border">
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="text_block block-1"
                                  role="presentation"
                                  style="
                                    mso-table-lspace: 0pt;
                                    mso-table-rspace: 0pt;
                                    word-break: break-word;
                                  "
                                  width="100%"
                                >
                                  <tr>
                                    <td
                                      class="pad"
                                      style="
                                        padding-left: 20px;
                                        padding-right: 20px;
                                        padding-top: 20px;
                                      "
                                    >
                                      <div style="font-family: Georgia, serif">
                                        <div
                                          class=""
                                          style="
                                            font-size: 14px;
                                            font-family: Georgia, Times,
                                              Times New Roman, serif;
                                            mso-line-height-alt: 16.8px;
                                            color: #2f2f2f;
                                            line-height: 1.2;
                                          "
                                        >
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 14px;
                                              text-align: center;
                                              mso-line-height-alt: 16.8px;
                                            "
                                          >
                                            Great news, we have a new client! 
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="text_block block-2"
                                  role="presentation"
                                  style="
                                    mso-table-lspace: 0pt;
                                    mso-table-rspace: 0pt;
                                    word-break: break-word;
                                  "
                                  width="100%"
                                >
                                  <tr>
                                    <td
                                      class="pad"
                                      style="
                                        padding-bottom: 25px;
                                        padding-left: 20px;
                                        padding-right: 20px;
                                      "
                                    >
                                      <div style="font-family: Georgia, serif">
                                        <div
                                          class=""
                                          style="
                                            font-size: 14px;
                                            font-family: Georgia, Times,
                                              Times New Roman, serif;
                                            mso-line-height-alt: 16.8px;
                                            color: #2f2f2f;
                                            line-height: 1.2;
                                          "
                                        >
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 14px;
                                              text-align: center;
                                              mso-line-height-alt: 16.8px;
                                            "
                                          >
                                            <span style="font-size: 42px"
                                              > Let's Get Started</span
                                            >
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="text_block block-3"
                                  role="presentation"
                                  style="
                                    mso-table-lspace: 0pt;
                                    mso-table-rspace: 0pt;
                                    word-break: break-word;
                                  "
                                  width="100%"
                                >
                                  <tr>
                                    <td
                                      class="pad"
                                      style="
                                        padding-bottom: 10px;
                                        padding-left: 30px;
                                        padding-right: 30px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <div style="font-family: sans-serif">
                                        <div
                                          class=""
                                          style="
                                            font-size: 14px;
                                            font-family: Arial, Helvetica Neue,
                                              Helvetica, sans-serif;
                                            mso-line-height-alt: 21px;
                                            color: #2f2f2f;
                                            line-height: 1.5;
                                          "
                                        >
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 16px;
                                              text-align: center;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            <span style="font-size: 16px"
                                              >Hello Amigos,</span
                                            >
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 16px;
                                              text-align: center;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            We are thrilled to welcome a new
                                            client on board and can't wait to
                                            start working with them. This is an
                                            exciting opportunity for us to
                                            showcase our skills and provide
                                            exceptional service to a new customer.
                                            Let's get started and make sure our
                                            new client feels valued and supported
                                            from day one!
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                                <table
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="text_block block-4"
                                  role="presentation"
                                  style="
                                    mso-table-lspace: 0pt;
                                    mso-table-rspace: 0pt;
                                    word-break: break-word;
                                  "
                                  width="100%"
                                >
                                  <tr>
                                    <td
                                      class="pad"
                                      style="
                                        padding-bottom: 10px;
                                        padding-left: 30px;
                                        padding-right: 30px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <div style="font-family: sans-serif">
                                        <div
                                          class=""
                                          style="
                                            font-size: 14px;
                                            font-family: Arial, Helvetica Neue,
                                              Helvetica, sans-serif;
                                            mso-line-height-alt: 21px;
                                            color: #2f2f2f;
                                            line-height: 1.5;
                                          "
                                        >
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 16px;
                                              text-align: center;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            Below are the contact details of the
                                            client. Please begin the discussions
                                            with the client
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              font-size: 16px;
                                              text-align: center;
                                              mso-line-height-alt: 21px;
                                            "
                                          >
                                             
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              mso-line-height-alt: 24px;
                                              text-transform: capitalize;
                                            "
                                          >
                                            Client Name : ${name}
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            Work Order ID: ${workorder_id}
                                          </p>
  
                                          <p
                                            style="
                                              margin: 0;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            Requirement : ${message}
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            Contact Email :
                                            <a
                                              href="mailto:balu249585@gmail.com"
                                              rel="noopener"
                                              style="
                                                text-decoration: underline;
                                                color: #8a3b8f;
                                              "
                                              target="_blank"
                                              >${email}</a
                                            >
                                          </p>
                                          <p
                                            style="
                                              margin: 0;
                                              mso-line-height-alt: 24px;
                                            "
                                          >
                                            Contact Number : ${phone_number}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-6"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #f6d16c;
                          color: #000000;
                          background-image: url('https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Fclient_email_template_images%2Fbackground-reminder.jpg?alt=media&token=371276e6-612a-4a63-9e76-1c2a7fab6c3d');
                          background-repeat: repeat;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                                background-color: #f6d16c;
  
                              "
                              width="100%"
                            >
                              <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                class="image_block block-1"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td
                                    class="pad"
                                    style="
                                      width: 100%;
                                      padding-right: 0px;
                                      padding-left: 0px;
                                    "
                                  >
                                    <div
                                      align="center"
                                      class="alignment"
                                      style="line-height: 10px"
                                    >
                                      <img
                                        alt="Girls Image"
                                        class="fullMobileWidth"
                                        src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Fclient_email_template_images%2FCustomer_Survey-amico.png?alt=media&token=02c08651-178e-455e-a2d1-f7b4843b7eab"
                                        style="
                                          display: block;
                                          height: auto;
                                          border: 0;
                                          width: 204px;
                                          max-width: 100%;
                                        "
                                        title="Girls Image"
                                        width="204"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-7"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #f6d16c;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                padding-bottom: 5px;
                                padding-top: 5px;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                                background-color: #ff9c27;
  
                              "
                              width="100%"
                            >
                              <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                class="image_block block-1"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td
                                    class="pad"
                                    style="
                                      width: 100%;
                                      padding-right: 0px;
                                      padding-left: 0px;
                                    "
                                  >
                                    <div
                                      align="center"
                                      class="alignment"
                                      style="line-height: 10px"
                                    >
                                      <img
                                        alt="Yourlogo Light"
                                        src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Fclient_email_template_images%2FGroup_6.png?alt=media&token=56e84d14-f674-4ce2-88d6-b9ccb6c3de95"
                                        style="
                                          display: block;
                                          height: auto;
                                          border: 0;
                                          width: 204px;
                                          max-width: 100%;
                                        "
                                        title="Yourlogo Light"
                                        width="204"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </table>
                              <table
                                border="0"
                                cellpadding="10"
                                cellspacing="0"
                                class="social_block block-2"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td class="pad">
                                    <div align="center" class="alignment">
                                      <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        class="social-table"
                                        role="presentation"
                                        style="
                                          mso-table-lspace: 0pt;
                                          mso-table-rspace: 0pt;
                                          display: inline-block;
                                        "
                                        width="108px"
                                      >
                                        <tr>
                                          <td style="padding: 0 2px 0 2px">
                                            <a
                                              href="https://www.facebook.com/"
                                              target="_self"
                                              ><img
                                                alt="Facebook"
                                                height="32"
                                                src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Facknowledgement%2Ffacebook2x.png?alt=media&token=a7fb8830-9e46-4476-80a7-cd98c64a917c"
                                                style="
                                                  display: block;
                                                  height: auto;
                                                  border: 0;
                                                "
                                                title="Facebook"
                                                width="32"
                                            /></a>
                                          </td>
                                          <td style="padding: 0 2px 0 2px">
                                            <a
                                              href="https://twitter.com/"
                                              target="_self"
                                              ><img
                                                alt="Twitter"
                                                height="32"
                                                src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Facknowledgement%2Ftwitter2x.png?alt=media&token=40758382-3afb-4d89-88e0-a9f9ad197290"
                                                style="
                                                  display: block;
                                                  height: auto;
                                                  border: 0;
                                                "
                                                title="Twitter"
                                                width="32"
                                            /></a>
                                          </td>
                                          <td style="padding: 0 2px 0 2px">
                                            <a
                                              href="https://instagram.com/"
                                              target="_self"
                                              ><img
                                                alt="Instagram"
                                                height="32"
                                                src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Facknowledgement%2Finstagram2x.png?alt=media&token=1a60e863-4f63-4cd6-91c7-830e0773dc10"
                                                style="
                                                  display: block;
                                                  height: auto;
                                                  border: 0;
                                                "
                                                title="Instagram"
                                                width="32"
                                            /></a>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                              <table
                                border="0"
                                cellpadding="10"
                                cellspacing="0"
                                class="text_block block-3"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                  word-break: break-word;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td class="pad">
                                    <div style="font-family: sans-serif">
                                      <div
                                        class=""
                                        style="
                                          font-size: 14px;
                                          font-family: Arial, Helvetica Neue,
                                            Helvetica, sans-serif;
                                          mso-line-height-alt: 21px;
                                          color: #f9f9f9;
                                          line-height: 1.5;
                                        "
                                      >
                                        <p
                                          style="
                                            margin: 0;
                                            text-align: center;
                                            mso-line-height-alt: 21px;
                                          "
                                        >
                                          ThanWe Consultants | Hitech city,
                                          Hyderabad India 500088<br />Made with ❤ 
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-8"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          background-color: #5d77a9;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                                background-color: #ff9c27;
  
                              "
                              width="100%"
                            >
                              <table
                                border="0"
                                cellpadding="10"
                                cellspacing="0"
                                class="text_block block-1"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                  word-break: break-word;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td class="pad">
                                    <div style="font-family: sans-serif">
                                      <div
                                        class=""
                                        style="
                                          font-size: 12px;
                                          font-family: Arial, Helvetica Neue,
                                            Helvetica, sans-serif;
                                          mso-line-height-alt: 14.399999999999999px;
                                          color: #cfceca;
                                          line-height: 1.2;
                                        "
                                      >
                                        <p
                                          style="
                                            margin: 0;
                                            font-size: 14px;
                                            text-align: center;
                                            mso-line-height-alt: 16.8px;
                                            color: white;
                                          "
                                        >
                                          © 2023 ThanWe Consultants Pvt Ltd.<br /> ThanWe
                                          Consultants and the ThanWe Consultants
                                          logo are registered trademarks of ThanWe
                                          Consultants, Pvt Ltd. All other
                                          trademarks are the property of their
                                          respective owners.
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="row row-9"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        class="row-content stack"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          color: #000000;
                          width: 680px;
                        "
                        width="680"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                padding-bottom: 5px;
                                padding-top: 5px;
                                vertical-align: top;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                              width="100%"
                            >
                              <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                class="icons_block block-1"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                                width="100%"
                              >
                                <tr>
                                  <td
                                    class="pad"
                                    style="
                                      vertical-align: middle;
                                      padding-bottom: 5px;
                                      padding-top: 5px;
                                      color: #9d9d9d;
                                      font-family: inherit;
                                      font-size: 15px;
                                      text-align: center;
                                    "
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      role="presentation"
                                      style="
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                      "
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          class="alignment"
                                          style="
                                            vertical-align: middle;
                                            text-align: center;
                                          "
                                        >
                                          <!--[if vml]><table align="left" cellpadding="0" cellspacing="0" role="presentation" style="display:inline-block;padding-left:0px;padding-right:0px;mso-table-lspace: 0pt;mso-table-rspace: 0pt;"><![endif]-->
                                          <!--[if !vml]><!-->
                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            class="icons-inner"
                                            role="presentation"
                                            style="
                                              mso-table-lspace: 0pt;
                                              mso-table-rspace: 0pt;
                                              display: inline-block;
                                              margin-right: -4px;
                                              padding-left: 0px;
                                              padding-right: 0px;
                                            "
                                          >
                                            <!--<![endif]-->
                                            <tr>
                                              <td
                                                style="
                                                  vertical-align: middle;
                                                  text-align: center;
                                                  padding-top: 5px;
                                                  padding-bottom: 5px;
                                                  padding-left: 5px;
                                                  padding-right: 6px;
                                                "
                                              >
                                                <a
                                                  href="https://www.designedwithbee.com/?utm_source=editor&utm_medium=bee_pro&utm_campaign=free_footer_link"
                                                  style="text-decoration: none"
                                                  target="_blank"
                                                  ><img
                                                    align="center"
                                                    alt="Designed with BEE"
                                                    class="icon"
                                                    height="32"
                                                    src="https://firebasestorage.googleapis.com/v0/b/thanwe-website.appspot.com/o/templates%2Facknowledgement%2Fbee.png?alt=media&token=f578940e-e52d-4f71-80b8-30842118f59c"
                                                    style="
                                                      display: block;
                                                      height: auto;
                                                      margin: 0 auto;
                                                      border: 0;
                                                    "
                                                    width="34"
                                                /></a>
                                              </td>
                                              <td
                                                style="
                                                  font-family: Arial,
                                                    Helvetica Neue, Helvetica,
                                                    sans-serif;
                                                  font-size: 15px;
                                                  color: #9d9d9d;
                                                  vertical-align: middle;
                                                  letter-spacing: undefined;
                                                  text-align: center;
                                                "
                                              >
                                                <a
                                                  href="https://www.designedwithbee.com/?utm_source=editor&utm_medium=bee_pro&utm_campaign=free_footer_link"
                                                  style="
                                                    color: #9d9d9d;
                                                    text-decoration: none;
                                                  "
                                                  target="_blank"
                                                  >Designed with BEE</a
                                                >
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- End -->
    </body>
  </html>
  
    `;
  };